import ZkInput from './src/input';

/* istanbul ignore next */
ZkInput.install = function(Vue) {
  Vue.component(ZkInput.name, ZkInput);
};

export default ZkInput;



// WEBPACK FOOTER //
// ./src/packages/input/index.js